<template>
  <div>
    <v-card class="white" style="border-radius: 30px; display: flex; margin-top: 10px;">
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12 class="pa-2 pt-2" style="font-size: 18px;">
            LINE WISE MAPPING
          </v-flex>
          <v-progress-linear :active="is_loading" :indeterminate="is_loading"
                             style="height: 4px; margin-top: 0px;"></v-progress-linear>
          <v-flex xs12 sm12 md12 lg7 style="float: right">
            <v-select
                :items="items"
                v-model="chart_line"
                solo clearable
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 class="pa-2 pt-2">
            <canvas ref="chart" id='chart1' style="position: relative; height:35vh;"></canvas>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "AllInOneGraph",
  watch: {
    chart_line: function (val){
      if(val != null || val != undefined){
        this.chart();
      }
      if(val ==  null || val == undefined){
        this.chart_line = "ALL"
        this.chart();
      }
    }
  },
  data: () => {
    return {
      is_loading: false,
      total_checkin: 0,
      length1: 0,
      myChart1: "",
      items: ['ALL', 'Central Line', 'Western Line', 'Harbour Line', 'Trans Harbour Line', 'Uran Line'],
      chart_line : "ALL"
    }
  },
  methods: {
    chart() {
      this.is_loading = true;

      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/get-graph-data`, {
                params:{
                  data: this.chart_line
                },
                headers: this.$headers })
          .then((response) => {
            if (response.data.status == 1) {
              // this.myChart1 = '';
              if (this.myChart1 != "") {
                this.myChart1.destroy();
              }
              let keys1 = response.data.dates;

              this.length1 = 0;
              var speedData = '';
              switch (this.chart_line) {
                case "ALL":
                  let values1 = response.data.allData;
                  let values11 = response.data.totalTrainCountAllTrains;

                  var MappingAll = {
                    label: "Mapped Trains",
                    data: values1,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(255,166,0,0.77)'
                  };

                  var MappingAll1 = {
                    label: "Total Trains",
                    data: values11,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(128,0,255,0.78)'
                  };

                  speedData = {
                    labels: keys1,
                    datasets: [MappingAll, MappingAll1]
                  };
                  break;

                case "Central Line":
                  let values5 = response.data.centralData;
                  let values55 = response.data.centralTotal;

                  var centralMapping5 = {
                    label: "Mapped Trains",
                    data: values5,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(255,166,0,0.76)'
                  };
                  var centralMappingtotal = {
                    label: "Total Trains",
                    data: values55,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(60,130,206,0.83)'
                  };
                  speedData = {
                    labels: keys1,
                    datasets: [centralMapping5, centralMappingtotal]
                  };
                  break;

                case "Harbour Line":
                  let values6 = response.data.harbourData;
                  let values66 = response.data.harbourTotal;
                  var harbourMapping = {
                    label: "Mapped Trains",
                    data: values6,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(135,196,109,0.82)'
                  };
                  var harbourMappingtotal = {
                    label: "Total Trains",
                    data: values66,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(255,99,97,0.83)'
                  };
                  speedData = {
                    labels: keys1,
                    datasets: [harbourMapping, harbourMappingtotal]
                  };
                  break;

                case "Trans Harbour Line":
                  let values7 = response.data.transHarbourData;
                  let values77 = response.data.transHarbourTotal;
                  var tranHarbourMapping7 = {
                    label: "Mapped Trains",
                    data: values7,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(89,239,9,0.84)'
                  };
                  var tranHarbourMappingtotal = {
                    label: "Total Trains",
                    data: values77,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(234,10,36,0.82)'
                  };
                  speedData = {
                    labels: keys1,
                    datasets: [tranHarbourMapping7, tranHarbourMappingtotal]
                  };
                  break;

                case "Uran Line":
                  let values8 = response.data.uranData;
                  let values88 = response.data.uranTotal;
                  var uranMapping8 = {
                    label: "Mapped Trains",
                    data: values8,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(188,80,144,0.85)'
                  };
                  var uranMappingTotal = {
                    label: "Total Trains",
                    data: values88,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(239,217,8,0.83)'
                  };

                  speedData = {
                    labels: keys1,
                    datasets: [uranMapping8, uranMappingTotal]
                  };
                  break;

                case "Western Line":
                  let values9 = response.data.westernData;
                  let values99 = response.data.westernTotal;
                  var westernMapping9 = {
                    label: "Mapped Trains",
                    data: values9,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(115,250,71,0.85)'
                  };
                  var westernMappingTotal = {
                    label: "Total Trains",
                    data: values99,
                    lineTension: 0,
                    fill: false,
                    borderColor: 'rgba(209,75,155,0.83)'
                  };

                  speedData = {
                    labels: keys1,
                    datasets: [westernMapping9, westernMappingTotal]
                  };
                  break;
              }

              var ctx1 = document.getElementById("chart1").getContext('2d');

              var chartOptions = '';
              if(this.chart_line == "Uran Line"){
                chartOptions = {
                  legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                      boxWidth: 40,
                      fontColor: 'black'
                    }
                  },
                  scales: {
                    yAxes: [{
                      ticks: {
                        beginAtZero: true,
                        stepSize: 20,
                        userCallback: function (label) {
                          // when the floored value is the same as the value we have a whole number
                          if (Math.floor(label) === label) {
                            return label;
                          }

                        },
                      },
                      stacked: true,
                    }],
                    xAxes: [{
                      stacked: true,
                    }],
                  }
                };
              }else {
                chartOptions = {
                  legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                      boxWidth: 40,
                      fontColor: 'black'
                    }
                  },
                  // scales: {
                  //   yAxes: [{
                  //     ticks: {
                  //       beginAtZero: true,
                  //       userCallback: function (label) {
                  //         // when the floored value is the same as the value we have a whole number
                  //         if (Math.floor(label) === label) {
                  //           return label;
                  //         }
                  //
                  //       },
                  //     },
                  //     stacked: true,
                  //   }],
                  //   xAxes: [{
                  //     stacked: true,
                  //   }],
                  // }
                };
              }

              this.myChart1 = new Chart(ctx1, {
                type: 'line',
                data: speedData,
                options: chartOptions
              });



              this.is_loading = false;
            } else {
              this.is_loading = false;
            }
          })
          .catch((error) => {
            // console.log(error);
          });
    }
  },
  mounted() {
    this.chart();
  }
}
</script>

<style scoped>

</style>
